import { GridValueGetterParams } from '@mui/x-data-grid-pro';
import { formatDateTimeUsWithTz } from 'functions/format/formatDate';

export const createdAtGetter = (params: GridValueGetterParams<any, any>) => {
  return formatDateTimeUsWithTz(new Date(params.row.createdAt));
};
